import Layout from './layout'

// 放单审核 - 商品列表
export default [
  {
    path: '/fangdan-audit',
    component: Layout,
    meta: { groupTitle: '品库后台', roles: ['admin'] },
    children: [
      {
        path: '',
        name: 'fangdanAuditList',
        component: () => import(/* webpackChunkName: "goodsList" */ '@v/fangdanAudit/goodsList'),
        meta: { title: '放单审核', icon: 'audit_admin' },
      },
      {
        path: 'detail/:id(\\d+|[new_]+\\d+)',
        name: 'fangdanAuditDetail',
        hidden: true,
        component: () => import(/* webpackChunkName: "goodsList" */ '@v/fangdanAudit/goodsDetail'),
        meta: {
          title: '放单审核 - 详细信息',
          icon: 'main',
          showBreadcrumb: true,
        },
      },
      {
        path: 'editgoods*',
        name: 'ContentManageEditGoods',
        hidden: true,
        component: () => import(/* webpackChunkName: "goodsList" */ '@v/fangdanAudit/goodsEdit'),
        meta: {
          title: '放单审核 - 编辑信息',
          icon: 'main',
          showBreadcrumb: true,
        },
      },
    ],
  },
]